import type { BluemineCatalogSlug } from './bluemineCatalogSlugs';

type IssueLinkParams = {
  template: 'issue';
  id: string | number;
};

type CatalogLinkParams = {
  template: 'catalog';
  id: string | number;
  catalogSlug: BluemineCatalogSlug;
};

export type BuildBluemineLinkUrlParams = IssueLinkParams | CatalogLinkParams;

export const buildBluemineLinkUrl = (
  baseUrl: string,
  params: BuildBluemineLinkUrlParams
): string => {
  const normalizedBase = baseUrl.replace(/\/$/, '');

  if (params.template === 'issue') {
    return `${normalizedBase}/issues/${params.id}`;
  }

  return `${normalizedBase}/entities/${params.catalogSlug}/${params.id}`;
};
